/**
 * @fileoverview Authentication module events.
 */

import { EVENT_PREFIX } from "../../core/events";

/**
 * Authentication events.
 */
export const AUTH_EVENTS = {
  /** Request token refresh (re-renders iframe with new token) */
  REFRESH: `${EVENT_PREFIX}auth.refresh`,
} as const;
